import { BUSINESS_INACTIVE_ERROR } from '@iws/backoffice-api'
import { useSyncExternalStore } from 'react'

let message: string | null = null
const listeners = new Set<() => void>()

export const noteBusinessInactive = (error: unknown) => {
  const response = (error as { response?: { status?: number; data?: { code?: string; message?: string } } })?.response
  if (response?.status !== 403 || response.data?.code !== BUSINESS_INACTIVE_ERROR || message) return
  message = response.data.message || 'This business is suspended. Contact support.'
  listeners.forEach((listener) => listener())
}

export const useBusinessInactive = () =>
  useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => message
  )
